module.exports = __webpack_public_path__ + "static/media/hackernews.22112dea.png";